// extracted by mini-css-extract-plugin
export default {"root":"ChipFilter_root__RKPu7","chip":"ChipFilter_chip__0sQpQ textBodyXs","chipSelected":"ChipFilter_chipSelected__bBHh7"};